import Loading from 'common/Components/Loading';
import { getCookies, getDomain, handleProductType } from 'common/method/helper';
import { Routes } from 'common/routes';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { callBackUrlSaveAction, isShowCaptchaInLoginAction } from 'redux/common/autorizationSlice';
import { useAuthorizationQuery } from 'services/login';
import './App.css';
import { useRouterExternal } from "common/hooks/useRouterExternal"
import ChatBot from 'common/Components/ChatBot';

function App() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation()
  const { pushExternal } = useRouterExternal()

  const removeClientId = () => {
    Cookies.remove('client_id', { path: "/", domain: getDomain() });
  };

  useEffect(() => {
    if (!window.api?.BROKER_CODE) {
      const clearTime = setTimeout(() => {
        window.location.reload()
        clearTimeout(clearTime)
      }, 1500);
    }
  }, [])



  useAuthorizationQuery(
    {
      productType: handleProductType(searchParams),
      token: getCookies() ? getCookies() : '',
      fingerId: Cookies.get('fingerId') ?? undefined,
    },
    {
      onSuccess: (data) => {
        const {
          succeeded,
          result: { callBackUrl, token, showCaptcha, hasFinger,showLoginWithBrokersSSO },
        } = data;
        try {
          dispatch(isShowCaptchaInLoginAction({ showCaptcha, hasFinger,showLoginWithBrokersSSO }))
        } catch { }
        if (succeeded) {
          if (pathname === "/login" || pathname === "/") {
            pushExternal(callBackUrl, token)
            return
          }
          dispatch(callBackUrlSaveAction(callBackUrl));
        } else {
          removeClientId();
        }
      },
      onError: () => {
        removeClientId();
      },
    }
  );

  const selectFavIcon = (brokerCode: number) => {
    return `/assets/images/Favicon${brokerCode}/favicon.ico`;
  };

  const selectAppleFavicon = (brokerCode: number) => {
    return `/assets/images/Favicon${brokerCode}/apple-touch-icon.png`;
  };

  useEffect(() => {
    let linkIcon = document.querySelector(
      "link[rel~='icon']"
    ) as HTMLLinkElement;
    let linkAppleIcon = document.querySelector(
      "link[rel~='apple-touch-icon']"
    ) as HTMLLinkElement;
    if (!linkIcon) {
      linkIcon = document.createElement('link');
      linkIcon.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(linkIcon);
    }
    linkIcon.href = selectFavIcon(window.api?.BROKER_CODE);
    linkAppleIcon.href = selectAppleFavicon(window.api?.BROKER_CODE);
  }, []);


  return (
    <HelmetProvider>
      <Loading />
      <Routes />
      <ChatBot />
    </HelmetProvider>
  );
}

export default App;
